// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LectureLessonStatusListResultModel from '../../model/lecture-lesson-status-list-result-model';
import LectureLessonStatusListResultDTO from '../dto/lecture-lesson-status-list-result-dto';
import dtoSchema from '../schemas/lecture-lesson-status-list-result-schema';
import LectureLessonStatusModel from '../../model/lecture-lesson-status-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class LectureLessonStatusListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LectureLessonStatusListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => LectureLessonStatusModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: LectureLessonStatusModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<LectureLessonStatusListResultDTO>): LectureLessonStatusListResultModel;
  static toModel(dto: DeepPartial<LectureLessonStatusListResultDTO> | undefined | null): LectureLessonStatusListResultModel | undefined;
  static toModel(dto: DeepPartial<LectureLessonStatusListResultDTO> | undefined | null): LectureLessonStatusListResultModel | undefined {
    return dto ? new LectureLessonStatusListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LectureLessonStatusListResultModel> | LectureLessonStatusListResultModel): LectureLessonStatusListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as LectureLessonStatusListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LectureLessonStatusListResultModel, can not map to LectureLessonStatusListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
